<template>
  <section class="tradition-section-container">
    <div class="content-wrapper">
      <div class="title">
        <h2>tradíció</h2>
        <div id="underline"></div>
      </div>
      <div class="subtext">
        <p>
          A fokos a magyarság egyik legmisztikusabb fegyvere. Számos monda és legenda kapcsolódik hozzá, amelyben a fokos a gonosz és a sötétség elleni küzdelem legfontosabb eszköze.
          <br><br>
          Az egyik leghíresebb történet a Szent László mondakörhöz kapcsolódik, amelyben a magyar király egy hosszú nyelű fokossal győzi le az íjjal sebezhetetlen kun harcost.
          <br><br>
          A fokos fontos szerepet töltött be a harcokban, az avatási rítusokban, a párbajokon, esküvőkön és a mulatságokon bemutatott táncok kiegészítő eszközeként, ezért a szükségszerű használaton túlmenően egyfajta kultikus nemzeti tárggyá is vált a magyarság körében.
        </p>
      </div>
      <div class="bottom-right-decor">
        <img src="../assets/background_elements/nepmese.png" alt="decoration">
      </div>
      <div class="up-left-decor">
        <img src="../assets/background_elements/nepmese_2.png" alt="decoration">
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "TraditionSection"
}
</script>

<style scoped>
.tradition-section-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  background: linear-gradient(180deg, #F2F2F2 0%, #EEEEEE 100%);
}

.content-wrapper {
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  padding: 7% 15vw;
}

h2 {
  font-size: 64px;
  font-weight: 900;
  text-transform: uppercase;
  line-height: 1.1;
}

#underline {
  background: #EFBE3E;
  height: 6px;
  width: 100%;
  border-radius: 10px;
}

.subtext {
  display: flex;
  justify-content: center;
  margin-top: 7vh;
  width: 70%;
  max-width: 840px;
  font-size: 18px;
  line-height: 200%;
}

.bottom-right-decor img {
  position: absolute;
  width: 20%;
  max-width: 450px;
  bottom: 0;
  right: 2%;
}

.up-left-decor img {
  position: absolute;
  width: 20%;
  max-width: 375px;
  top: 3%;
  left: 0
}

@media only screen and (max-width: 900px) {
  img {
    display: none;
  }

  .content-wrapper {
    padding: 7% 0;
  }

  h2 {
    margin-top: 25px;
    font-size: 48px;
  }

  .subtext {
    width: 100%;
    padding: 0 7%;
    margin-top: 40px;
  }
}

@media only screen and (max-width: 600px) {
  h2 {
    font-size: 34px;
  }
}

</style>
